/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fRuRbcdHVNMtdcnFK96ivt
import { createUseStyleTokens } from "@plasmicapp/react-web";
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/projectModule
import projectcss from "./plasmic.module.css"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/projectcss
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss

const data = {
  base: `${projectcss.plasmic_tokens} ${plasmic_antd_5_hostless_css.plasmic_tokens} ${plasmic_plasmic_rich_components_css.plasmic_tokens}`,
  varianted: []
};

export const _useStyleTokens = createUseStyleTokens(data, _useGlobalVariants);
